import { render, staticRenderFns } from "./ArtistForm.vue?vue&type=template&id=044eef30&scoped=true&"
import script from "./ArtistForm.vue?vue&type=script&lang=ts&"
export * from "./ArtistForm.vue?vue&type=script&lang=ts&"
import style0 from "./ArtistForm.vue?vue&type=style&index=0&id=044eef30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044eef30",
  null
  
)

export default component.exports